import React from 'react';
import { FlexSpacer, IconButton, Text } from '@epam/promo';
import { ReactComponent as CloseIcon } from '@epam/assets/icons/common/navigation-close-18.svg';
import { ReactComponent as ErrorIcon } from '@epam/assets/icons/common/notification-error-fill-24.svg';
import { useSystemStatus } from 'services/system-status/system-status-provider';
import styles from './SystemStatusBanner.module.scss';

export const SystemStatusBanner: React.FC = () => {
  const { showBanner, failureReasons, dismiss } = useSystemStatus();

  if (!showBanner) return null;

  return (
    <div className={styles.banner} role="alert" aria-live="assertive">
      <div className={styles.row}>
        <ErrorIcon className={styles.icon} />
        <div className={styles.content}>
          <Text cx={styles.title} font="sans-semibold" fontSize="14">
            We're working to restore service. Please try again later...
          </Text>
          {failureReasons.length > 0 && (
            <ul className={styles.reasons}>
              {failureReasons.map((reason) => (
                <li key={reason}>
                  <Text cx={styles.reasonText} fontSize="12">
                    {reason}
                  </Text>
                </li>
              ))}
            </ul>
          )}
        </div>
        <FlexSpacer />
        <IconButton
          icon={CloseIcon}
          onClick={dismiss}
          cx={styles.closeButton}
        />
      </div>
    </div>
  );
};
